import { toast as toastify, type ToastOptions } from 'vue3-toastify';

import { TOASTS_ENABLED } from 'src/shared/constants';

function showToast(
  fn: (message: string, options?: ToastOptions) => string | number | undefined,
  message: string,
  options?: ToastOptions,
): string | number | undefined {
  if (!TOASTS_ENABLED) return undefined;
  return fn(message, options);
}

export const toast = {
  success: (message: string, options?: ToastOptions) => showToast(toastify.success, message, options),
  error: (message: string, options?: ToastOptions) => showToast(toastify.error, message, options),
  info: (message: string, options?: ToastOptions) => showToast(toastify.info, message, options),
  warning: (message: string, options?: ToastOptions) => showToast(toastify.warning, message, options),
};
